import {
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
} from './actionTypes';

const initialState = {
  isVisible: false,
  type: 'info',
  title: '',
  subtitle: '',
  buttonData: null,
  isSticky: false,
  autoDismiss: false,
  dismissDelay: 6000,
  closeButtonClick: null,
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return {
        ...state,
        ...(action.payload || {}),
        isVisible: true,
      };

    case HIDE_NOTIFICATION:
      return {
        ...state,
        isVisible: false,
      };

    default:
      return state;
  }
};
